
import axios from "axios";

export const ORDER_CREATE_REQUEST =
  "ORDER_CREATE_REQUEST";

export const ORDER_CREATE_SUCCESS =
  "ORDER_CREATE_SUCCESS";

export const ORDER_CREATE_FAIL =
  "ORDER_CREATE_FAIL";


// ==========================================
// GET DJANGO CSRF TOKEN
// ==========================================

const getCsrfToken = async () => {
  const response = await axios.get(
    "/api/kitchen/csrf/",
    {
      withCredentials: true,
    }
  );

  const token = response.data?.csrfToken;

  if (!token) {
    throw new Error(
      "Unable to obtain CSRF token from server."
    );
  }

  return token;
};


// ==========================================
// CREATE ORDER
// ==========================================

export const createOrder =
  (restaurantId, orderData) =>
  async (dispatch) => {

    try {

      dispatch({
        type: ORDER_CREATE_REQUEST,
      });


      // Step 1: Obtain CSRF token from Django
      const csrfToken = await getCsrfToken();


      // Step 2: Submit order with CSRF token
      const response = await axios.post(
        `/api/restaurants/${restaurantId}/orders/`,
        orderData,
        {
          withCredentials: true,

          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
        }
      );


      console.log(
        "ORDER API RESPONSE:",
        response.data
      );


      dispatch({
        type: ORDER_CREATE_SUCCESS,
        payload: response.data.order,
      });


      return response.data.order;

    } catch (error) {

      console.log(
        "ORDER API STATUS:",
        error.response?.status
      );

      console.log(
        "ORDER API RESPONSE:",
        error.response?.data
      );

      // Avoid logging complete customer order data
      // because it may contain personal information.


      const errorData =
        error.response?.data;


      const message =
        errorData?.detail ||
        errorData?.error ||
        error.message ||
        "Failed to create order";


      dispatch({
        type: ORDER_CREATE_FAIL,

        payload: {
          message: message,

          code:
            errorData?.code ||
            null,
        },
      });


      throw error;
    }
  };
